import * as React from 'react';
import { SVGProps } from 'react';

const SvgUpload = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={17} height={17} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.015 12.621a.727.727 0 0 0 .728-.727v-8.91l3.606 3.606a.727.727 0 0 0 1.029-1.029L9.538.722A.725.725 0 0 0 8.501.713L3.652 5.561A.727.727 0 1 0 4.681 6.59l3.607-3.607v8.91c0 .403.326.728.727.728Zm-6.788 2.425a.727.727 0 1 0 0 1.454h13.576a.727.727 0 1 0 0-1.454H2.227Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgUpload;
